import moment from 'moment';
import { initialValues } from './filters.config';

export const convertDataToForm = (data) => {
  if (!data || data.length === 0) {
    return initialValues;
  }

  const invoiceType = data.find((filter) => filter.type === 'invoiceType');
  const issueDateType = data.find((filter) => filter.type === 'issueDateType');
  const issueDateFrom = data.find((filter) => filter.type === 'issueDateFrom');
  const issueDateTo = data.find((filter) => filter.type === 'issueDateTo');
  const issueDate = data.find((filter) => filter.type === 'issueDate');
  const invoiceNumber = data.find((filter) => filter.type === 'invoiceNumber');
  const invoiceSubType = data.find(
    (filter) => filter.type === 'invoiceSubType',
  );
  const vatAccountType = data.find(
    (filter) => filter.type === 'vatAccountType',
  );
  const vatAccountNumber = data.find(
    (filter) => filter.type === 'vatAccountNumber',
  );
  const netMinAmount = data.find((filter) => filter.type === 'netMinAmount');
  const netMaxAmount = data.find((filter) => filter.type === 'netMaxAmount');
  const vatMinAmount = data.find((filter) => filter.type === 'vatMinAmount');
  const vatMaxAmount = data.find((filter) => filter.type === 'vatMaxAmount');
  const grossMinAmount = data.find(
    (filter) => filter.type === 'grossMinAmount',
  );
  const grossMaxAmount = data.find(
    (filter) => filter.type === 'grossMaxAmount',
  );
  const transactionType = data.find(
    (filter) => filter.type === 'transactionType',
  );
  const generatedBy = data.find((filter) => filter.type === 'generatedBy');
  const fullOrSimplified = data.find(
    (filter) => filter.type === 'fullOrSimplified',
  );
  const buyerName = data.find((filter) => filter.type === 'buyerName');

  return {
    invoiceType,
    issueDateType,
    issueDateFrom,
    issueDateTo,
    issueDate,
    invoiceNumber,
    invoiceSubType,
    vatAccountType,
    vatAccountNumber,
    netAmountType: 'range',
    netMinAmount,
    netMaxAmount,
    vatAmountType: 'range',
    vatMinAmount,
    vatMaxAmount,
    grossAmountType: 'range',
    grossMinAmount,
    grossMaxAmount,
    transactionType,
    generatedBy,
    fullOrSimplified,
    buyerName,
  };
};

export const filterData = (filter, originalData) => {
  let filteredData = [...originalData];

  if (filter.issueDateFrom) {
    filteredData = filteredData.filter((ele) =>
      moment(ele.issueDate, 'YYYY-MM-DD hh:mm:ss').isSameOrAfter(
        moment(filter.issueDateFrom, 'DD/MM/YYYY'),
      ),
    );
  }

  if (filter.issueDateTo) {
    filteredData = filteredData.filter((ele) =>
      moment(ele.issueDate, 'YYYY-MM-DD hh:mm:ss').isSameOrBefore(
        moment(filter.issueDateTo, 'DD/MM/YYYY'),
      ),
    );
  }

  if (filter.invoiceSubType) {
    filteredData = filteredData.filter(
      (ele) => filter.invoiceSubType === ele.invoiceType,
    );
  }

  if (filter.generatedBy.length > 0) {
    filteredData = filteredData.filter((ele) =>
      filter.generatedBy.includes(ele.generatedBy),
    );
  }

  if (filter.grossMaxAmount) {
    filteredData = filteredData.filter(
      (ele) => parseFloat(ele.grossTotal) <= parseFloat(filter.grossMaxAmount),
    );
  }

  if (filter.grossMinAmount) {
    filteredData = filteredData.filter(
      (ele) => parseFloat(ele.grossTotal) >= parseFloat(filter.grossMinAmount),
    );
  }

  if (filter.netMaxAmount) {
    filteredData = filteredData.filter(
      (ele) => parseFloat(ele.netAmount) <= parseFloat(filter.netMaxAmount),
    );
  }

  if (filter.netMinAmount) {
    filteredData = filteredData.filter(
      (ele) => parseFloat(ele.netAmount) >= parseFloat(filter.netMinAmount),
    );
  }

  if (filter.vatMinAmount) {
    filteredData = filteredData.filter(
      (ele) => parseFloat(ele.vatAmount) >= parseFloat(filter.vatMinAmount),
    );
  }

  if (filter.vatMaxAmount) {
    filteredData = filteredData.filter(
      (ele) => parseFloat(ele.vatAmount) <= parseFloat(filter.vatMaxAmount),
    );
  }

  if (filter.vatAccountNumber) {
    filteredData = filteredData.filter(
      (ele) =>
        filter.vatAccountNumber.toString() ===
        ele.buyerVatAccountNumber.toString(),
    );
  }

  return filteredData;
};

export const getUniqueColumnValues = (arr, columns, t) => {
  const result = {};

  columns.forEach((filterConfig) => {
    result[filterConfig.key] = [
      ...new Set(arr.map((item) => item[filterConfig.key])),
    ].map((item) => filterConfig.option(item, t));
  });

  return result;
};
